import ErrorText from "../ErrorText/errorText";

const CustomInput = ({
  label,
  type = "text",
  as = "input",
  name,
  className = "",
  rows = 4,
  checked,
  message,
  requir = false,
  ...props
}) => {
  const baseInputClasses =
    "w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor";

  const checkboxRadioClasses =
    "h-4 w-4 text-themeColor border-gray-300 focus:ring-themeColor";

  if (as === "textarea") {
    return (
      <div className="mb-4">
        {label && (
          <label
            htmlFor={name}
            className="block font-medium mb-1 text-gray-700 text-left"
          >
            {label} {requir && <span className="text-red-500">*</span>}
          </label>
        )}
        <textarea
          id={name}
          name={name}
          rows={rows}
          className={`${baseInputClasses} ${className}`}
          {...props}
        />
        {message && <ErrorText message={message} />}
      </div>
    );
  }

  if (type === "checkbox" || type === "radio") {
    return (
      <div className="flex items-center space-x-2">
        <input
          id={name}
          name={name}
          type={type}
          checked={checked}
          className={`${checkboxRadioClasses} ${className}`}
          {...props}
        />
        {message && <ErrorText message={message} />}
        {label && (
          <label htmlFor={name} className="text-gray-700">
            {label}
          </label>
        )}
      </div>
    );
  }

  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={name} className="block font-medium mb-1 text-gray-700">
          {label} {requir && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        id={name}
        name={name}
        type={type}
        className={`${baseInputClasses} ${className}`}
        {...props}
      />
      {message && <ErrorText message={message} />}
    </div>
  );
};

export default CustomInput;
